module.exports = __webpack_public_path__ + "images/b0e4076521167edddfe9697c286abba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-miniposter.jpg
// module id = ./webpack/assets/img/diaryofanant-miniposter.jpg
// module chunks = 0